import React, { useRef, useEffect } from 'react'
import DocSearchCriteria from './DocSearchCriteria'
import DocCriteriaEditor from './DocCriteriaEditor'
import DocSearchGroups from './DocSearchGroups'
import DocSearchSaveFavorite from './DocSearchSaveFavorite'
import { buildCriteriaValueFromJsonList, buildSearchCriteria, saveFavCriteria, deleteFavourite, buildSearchCriteriaFromString } from './DocSCFunctions'
import ActionButton from '../../../../library/input/buttons/button/SarasButton';
import DocSearchFavourite from './DocSearchFavourite'
import DocSearchCriteriaList from './DocSearchCriteriaList'
import DocSearchSort from './DocSearchSort'
import DocSearchBirdEyeView from './DocSearchBirdEyeView'
import DocSearchDynamicGroup from './DocSearchDynamicGroup'
import DocPaging from '../../DocPaging'
import * as formJS from '../../docAutomation/formFunctions';
import SarasTrans from '../../../../library/notifications/SarasTrans'
import SarasChip from '../../../../library/repeater/list/SarasChip';
import ColumnSelector from '../columnSelector/ColumnSelector'

const DocSearch = (props) => {
    const { viewData, onSearchByGroup, onChangeSort, deviceInfo, 
        onBirdEyeView, onPageChange, reloadSearch, birdEyeViewData, defaultGroup, 
        onSearchByCriteria, dynamicGroupManager,
        shortcutSearchRequested, enableSearch, enableGroups, enablefav, rptKey, 
        actionName, disableSearch, userColumns, inlineCriteria = false } = props

    // const dynamicGroupList = viewData.childViews.dynamicGroupView ? viewData.childViews.dynamicGroupView.viewRows : {};
    const favouriteList = viewData.childViews.favView ? viewData.childViews.favView.viewRows : {};
    const sortList = viewData.childViews.sortView ? viewData.childViews.sortView.viewRows : {};
    const enableBirdEyeView = formJS.getValueFromKey(viewData, "childViews.resultView.dataList.enableBirdEyeView", "0");
    const sortKey = formJS.getValueFromKey(viewData, "childViews.sortView.dataList.sortKey", "");

    // console.log("DocSearch",viewData,favouriteList)
    const [scList, setSCList] = React.useState(viewData.childViews.criteriaView.viewRows);
    const [favList, setFavList] = React.useState(favouriteList);//viewData.favourites
    const [popupName, setPopupName] = React.useState('');
    const [popupAnchor, setPopupAnchor] = React.useState(null);
    const [currentSortKey, setCurrentSortKey] = React.useState("");
    const [currentCriteria, setCurrentCriteria] = React.useState({});
    const [criteriaKey, setCriteriaKey] = React.useState("");
    const [currentGroupKey, setCurrentGroupKey] = React.useState("");

    const addFavRef = useRef(null);
    const scListRef = useRef();
    const showBirdEyeRef = useRef(null);

    scListRef.current = scList;

    const updateShortcutSearchRequest = () => {
        //open criteria editor
        // console.log("short cut search request", shortcutSearchRequested);
        if (shortcutSearchRequested && shortcutSearchRequested.fieldKey && shortcutSearchRequested.targetRef) {
            // console.log("short cut search request", shortcutSearchRequested);
            setCurrentCriteria(null);
            setCriteriaKey("");
            setPopupAnchor(shortcutSearchRequested.targetRef);
            setPopupName("criteriaEditor");
        }
    }

    //ensure state is updated whenever the props are changed by parent
    useEffect(updateShortcutSearchRequest, [shortcutSearchRequested]);
    
    const updateDefaultCriteria = () => {
        if (defaultGroup) {
            setCurrentGroupKey(defaultGroup);
        }
    }

    useEffect(updateDefaultCriteria, [defaultGroup]);

    const updateCriteriaStateFromProps = () => {
        // console.log("criteria list changed");
        setSCList(viewData.childViews.criteriaView.viewRows);
    }

    //ensure state is updated whenever the props are changed by parent
    useEffect(updateCriteriaStateFromProps, [props.viewData.childViews.criteriaView]);

    const updateFavStateFromProps = () => {
        if(viewData.childViews.favView)
            setFavList(viewData.childViews.favView.viewRows);
        else    
            setFavList({});
    }

    //ensure state is updated whenever the props are changed by parent
    useEffect(updateFavStateFromProps, [props.viewData.childViews.favView]);

    const onSearchRequested = (reload, criteriaList) => {
        if (criteriaList === undefined) criteriaList = scList;

        // console.log("search requested");

        let criteriaValue = buildCriteriaValueFromJsonList(criteriaList);

        if (onSearchByCriteria) onSearchByCriteria(reload, criteriaValue);
    }

    const addSearchCriteria = (newCriteria) => {
        // console.log('new criteria', criteria);
        let newSCList = { ...scListRef.current }
        newSCList[newCriteria.rowKey] = newCriteria;
        // console.log('after adding to the new', newSCList);
        // console.log('scan criteria list', scList, newSCList);
        
        setSCList({ ...newSCList });

        //fire search
        onSearchRequested(1, newSCList);
    }

    const updateCriteriaChanges = (criteriaObj, newField, newCond, newVal1, newVal2) => {
        // console.log("criteria updated", criteriaObj, newField, newCond, newVal1, newVal2);

        //TODO update criteria
        //if criteriaObj is available it means existing criteria is being edited
        //else create a new criteria object

        //do not build if the new value is blank
        if(!newVal1) return;

        let newCriteria = buildSearchCriteria(criteriaObj, newField, newCond, newVal1, newVal2, viewData.childViews.fieldView.viewRows);
        if (newCriteria) addSearchCriteria(newCriteria);

        //remove popup
        setCurrentCriteria(null);
        setCriteriaKey("");
        setPopupAnchor(null);
        setPopupName("");
    }

    const onSearchGroupChange = (groupKey) => {
        //retain the last selection
        setCurrentGroupKey(groupKey);

        if (onSearchByGroup) onSearchByGroup(groupKey);
    }

    const cancelCriteriaChanges = () => {
        // console.log("criteria canceled");
        //remove popup
        setCurrentCriteria(null);
        setCriteriaKey("");
        setPopupAnchor(null);
        setPopupName("");
    }

    const deleteCriteria = (fieldKey, isPopup) => {
        //delete popup
        //delete criteria
        let newSCList = { ...scList }

        // console.log('current criteria list', newSCList);
        delete newSCList[fieldKey];
        // console.log('criteria list after delete', newSCList);

        setSCList({ ...newSCList });

        //fire search
        onSearchRequested(1, newSCList);
        
        if(isPopup)
        {
            setCurrentCriteria(null);
            setCriteriaKey("");
            setPopupAnchor(null);
            setPopupName("");
        }
    }

    const onCriteriaAction = (anchorRef, fieldKey, action) => {
        //open criteria editor or delete criteria
        // console.log("on criteria clicked", anchorRef, rowKey, action);

        if (action === "action-delete") {
            deleteCriteria(fieldKey, false);
        }
        else {
            //open criteria editor
            setCurrentCriteria(scList[fieldKey]);
            setCriteriaKey(fieldKey);
            setPopupAnchor(anchorRef);
            setPopupName("criteriaEditor");
        }
    }

    const onCallSaveFavorite = () => {
        setPopupAnchor(addFavRef);
        setPopupName("addFav");
    }

    const onFavSelected = (e, index) => {
        // console.log("props in fav click event", e.currentTarget.classList, e.target.classList, index);
        //let favList = viewData.childViews.favView.viewRows;
        let favRowClicked = favList[Object.keys(favList)[index]];
        // console.log("fav row object", favRowClicked, favList);
        if (!favRowClicked || favRowClicked.length === 0) return;
        let favCriteriaVal = favRowClicked.dataList.cv;
        let classClicked = e.currentTarget.classList;

        if (classClicked.contains('action-delete')) {
            //fire delete favorite
            // console.log("fire delete fav", favRowClicked);
            deleteFavourite(favRowClicked.rowKey, viewData.masterKeys.dtId, currentGroupKey, onFavSuccessCallBack, rptKey, actionName)
        }
        else {
            //fire search by favorite
            // console.log("fire search by fav", favRowClicked.rowKey);

            let newSCList = buildSearchCriteriaFromString(favCriteriaVal, viewData.childViews.fieldView.viewRows)
            setSCList({ ...newSCList });
            if (onSearchByCriteria) {
                onSearchRequested(1, newSCList);
            } //onSearchByFavorite(favRowClicked.rowKey,favCriteriaVal);
        }
    }

    const onSaveFavorite = (name) => {
        if (scList !== undefined) {
            let criteriaValue = buildCriteriaValueFromJsonList(scList);

            saveFavCriteria(criteriaValue, name, viewData.masterKeys.dtId, currentGroupKey, onFavSuccessCallBack, rptKey, actionName)
            /*newFav.criteria = [...scList]
            list.push({ ...newFav })
            setFavList([...list])*/
            // console.log('testinh hhh',list)
        }
    }

    const onFavSuccessCallBack = (response) => {
        // console.log('fav response', response)
        if (response)
            setFavList(response.data.mainViewData.viewRows)
    }

    const onBirdEyeViewClick = () => {
        onShowBirdEyeView(showBirdEyeRef);
    }

    const onColumnManagerClick = () => {
        setPopupAnchor(null);
        setPopupName("showColumnManager");
    }

    const cancelColumnManager = () => {
        // console.log("criteria canceled");
        //remove popup
        setPopupAnchor(null);
        setPopupName("");
    }

    const confirmColumnManager = () => {
        // console.log("criteria canceled");
        //remove popup
        setPopupAnchor(null);
        setPopupName("");
        onRefreshClick();
    }

    const onRefreshClick = () => {
        if (reloadSearch) reloadSearch(1);
    }

    const onShowBirdEyeView = (anchorRef) => {
        if(popupName === "showBirdEyeView"){
            setPopupAnchor(null);
            setPopupName("");
        }
        else{
            //trigger server request
            if (onBirdEyeView) onBirdEyeView();

            //show the popup
            setPopupAnchor(anchorRef);
            setPopupName("showBirdEyeView");
        }
    }

    const onSortSelected = (key) => {
        setCurrentSortKey(key);

        if(onChangeSort) onChangeSort(key);
    }

    const renderPopup = () => {
        if (popupName === "showColumnManager"){
            return (<ColumnSelector viewData={userColumns} onCancel={cancelColumnManager} onConfirm={confirmColumnManager} />);
        }
        
        if (popupAnchor == null) return null;

        if (popupName === 'addFav') {
            return (<DocSearchSaveFavorite targetRef={popupAnchor} addFav={onSaveFavorite} onCancel={setPopupName} />);
        }
        else if (popupName === "showBirdEyeView"){
            return (<DocSearchBirdEyeView targetRef={popupAnchor} birdEyeViewData={birdEyeViewData} onCancel={setPopupName} />);
        }
        else if (popupName === "criteriaEditor") {
            // console.log("render criteria editor 2", currentCriteria, criteriaKey);

            return (
                <DocCriteriaEditor targetRef={popupAnchor} criteriaObj={currentCriteria}
                    criteriaKey={criteriaKey || (shortcutSearchRequested ? shortcutSearchRequested.fieldKey : undefined)}
                    fields={viewData.childViews.fieldView.viewRows}
                    conditions={viewData.childViews.conditionView.viewRows}
                    onUpdate={updateCriteriaChanges}
                    onCancel={cancelCriteriaChanges}
                    onDelete={deleteCriteria}
                />
            )
        }

        return null;
    }

    const renderSearchDynamicGroups = () => {
        if (enableGroups && dynamicGroupManager.dynamicGroupData && Object.keys(dynamicGroupManager.dynamicGroupData).length > 0) {
            return (
                <div className='uiFlexBox saras-tour-search-results-filter-group'>
                    <DocSearchDynamicGroup deviceInfo={deviceInfo} dynamicGroupManager={dynamicGroupManager} />
                </div>
            )
        }
        else
            return null
    }

    const renderGroupManager = () => {
        if(!dynamicGroupManager) return null;

        let group = dynamicGroupManager.getSelectedGroupLabels();

        return (
            <>
                {group ?
                    <div className='uiFlexBox3'>
                        <span className='uiSelectedCriteriaLabel'><SarasTrans value="Group by" />:</span>
                        <div className='uiSelectedGroup'>
                            <SarasChip className='uiSearchCriteriaChip' data={{ key: group, val: group }} onDelete={() => dynamicGroupManager.onClearGroupSelection()} />
                        </div>
                    </div>
                : null}
            </>
        )
    }

    const renderSelectedCriteria = () => {
        if (!scList || Object.keys(scList).length === 0) return null;

        return (
            <div className="uiFlexBox3" style={inlineCriteria ? { minWidth: 0 } : undefined}>
                <span className="uiSelectedCriteriaLabel"><SarasTrans value="Filter" />:</span>
                {/*Keep long chip lists scrollable without pushing the adjacent toolbar actions away.*/}
                <div className="uiSelectedCriteria"
                    style={inlineCriteria ? { marginTop: 0, minWidth: 0, maxWidth: 'min(360px, 30vw)' } : undefined}>
                    <DocSearchCriteriaList viewData={scList} onCriteriaAction={onCriteriaAction} />
                </div>
            </div>
        );
    };

    if(disableSearch){
        return(null);
    }

    return (
        <>
            <div className="uiCMNSearchHeader">
                <div className="phSearchPanel">
                    <div className='uiFlexDistributed'>
                        <div className="uiSearchCriteria">
                            <div className='uiFlexBox'>
                                {enableGroups ? <>
                                        <div className='saras-tour-search-results-filter-view'>
                                            <DocSearchGroups viewData={viewData.childViews.groupView.viewRows}
                                                previousGroupKey={currentGroupKey}
                                                onSearchGroupChange={onSearchGroupChange} />
                                        </div>
                                        {renderSearchDynamicGroups()}
                                     </>
                                : null}
                                <div className='saras-tour-search-results-filter-general'>
                                    <DocSearchCriteria viewData={viewData}
                                        key={currentGroupKey}
                                        currentGroupKey={currentGroupKey}
                                        addSearchCriteria={addSearchCriteria}
                                        onSearchRequested={onSearchRequested}
                                        onCriteriaAction={onCriteriaAction}
                                    />
                                </div>
                                <div>
                                    {enablefav !== false ?
                                        <div ref={addFavRef} className="uiFlexBox3 uiActionWithMenu saras-tour-search-results-filter-favorite">
                                            <ActionButton ksc="f" onClick={onCallSaveFavorite} starIcon="star" 
                                                tooltip="Add current filters to favorite"
                                                starIconClassName=""
                                                onlyIcon={true}
                                                className="uiLink uiIcon"/>
                                            <DocSearchFavourite onFavSelected={onFavSelected} viewData={favList} 
                                                tooltip="Select filter from favorite"/>
                                        </div> : null}
                                </div>
                                {inlineCriteria ? renderSelectedCriteria() : null}
                            </div>
                        </div>
                        {enableSearch ? 
                        <div className='uiFlexBox'>
                            <div className='saras-tour-search-results-filter-sort'>
                                <DocSearchSort currentKey={currentSortKey || sortKey} onSortSelected={onSortSelected} viewData={sortList} />
                            </div>
                            {userColumns.columns ? <div>
                                <ActionButton ksc="c" onClick={onColumnManagerClick} starIcon="column-manager" 
                                    tooltip="Column Manager"
                                    onlyIcon={true}
                                    className="uiLink uiIcon saras-tour-search-results-filter-summary"/>
                            </div> : null}
                            {enableBirdEyeView === "1" ? <div ref={showBirdEyeRef}>
                                <ActionButton ksc="b" onClick={onBirdEyeViewClick} starIcon="birdeye" 
                                    tooltip="Show summary"
                                    onlyIcon={true}
                                    className="uiLink uiIcon saras-tour-search-results-filter-summary"/>
                            </div> : null}
                            <div>
                                <ActionButton ksc="r" onClick={onRefreshClick} 
                                        tooltip="Refresh data"
                                        onlyIcon={true}
                                        starIcon="refresh" 
                                        className="uiLink uiIcon saras-tour-search-results-filter-reload" />
                            </div>
                            <div className='saras-tour-search-results-filter-paging'>
                                <DocPaging paging={viewData.childViews.resultView.paging} onPageChange={onPageChange} hidePageIfNR={false} />
                            </div>
                        </div> : null}
                    </div>
                    <div className='uiFlexBox15'>
                        {renderGroupManager()}
                        {!inlineCriteria ? renderSelectedCriteria() : null}
                    </div>
                </div>
            </div>
            {renderPopup()}
        </>
    )
}

export default DocSearch
